// ============================================================================
// StopAiButton
// ----------------------------------------------------------------------------
// TS-060 / DEC-COUNCIL-015 T3 (QuoteMakerNavBar sub-slice): extracted VERBATIM
// from App.jsx's action cluster; encapsulates its own `hasLivePipelineEntry`
// null-gate (like AiPipelineStatus); App owns `cancelAiPipeline`, passed as
// `onStop`. Pure presentational, imports Icons.
// ============================================================================

import React from 'react';
import { Icons } from './Icon';

interface StopAiButtonProps {
    /** Whether a live PipelineMonitor entry exists - the same gate the inline IIFE used; when false the button renders nothing. */
    hasLivePipelineEntry: boolean;
    /** Risk analysis is running. */
    isAnalyzing: boolean;
    /** Project summary generation is running. */
    isSummarizing: boolean;
    /** Work-method (WMS) generation is running. */
    projectWMSGenerating: boolean;
    /** Photo allocation is running. */
    photoAssignBusy: boolean;
    /** Quote generation is running. */
    isGenerating: boolean;
    /** Invoked when the STOP button is clicked (App wires this to `cancelAiPipeline`). */
    onStop: () => void;
}

export function StopAiButton({
    hasLivePipelineEntry,
    isAnalyzing,
    isSummarizing,
    projectWMSGenerating,
    photoAssignBusy,
    isGenerating,
    onStop,
}: StopAiButtonProps) {
    if (!hasLivePipelineEntry) return null;
    const runningParts: string[] = [];
    if (isAnalyzing) runningParts.push('analysis');
    if (isSummarizing) runningParts.push('summary');
    if (projectWMSGenerating) runningParts.push('work method');
    if (photoAssignBusy) runningParts.push('photo allocation');
    if (isGenerating) runningParts.push('quote gen');
    return (
        <button
            type="button"
            onClick={onStop}
            className="btn-nav-new accent-red qm-nav-stop"
            aria-label="Stop AI pipeline"
            title={`Stop ${runningParts.join(', ') || 'the AI pipeline'} now`}
        >
            <Icons.X size={13} aria-hidden="true" />
            <span>STOP</span>
        </button>
    );
}
